// extracted by mini-css-extract-plugin
export var attribution = "footer-module--attribution--9111f";
export var basicLink = "footer-module--basic-link--91c64";
export var column = "footer-module--column--bc2f7";
export var contact = "footer-module--contact--c4ada";
export var container = "footer-module--container--75fee";
export var legal = "footer-module--legal--b32fa";
export var logo = "footer-module--logo--7b0d5";
export var logoLink = "footer-module--logo-link--64468";
export var row = "footer-module--row--6d539";
export var socialWrapper = "footer-module--social-wrapper--98459";
export var textColumn = "footer-module--text-column--5f233";